import { ChevronDownIcon, ChevronRightIcon } from '../../Icons';
import { jsx as _jsx } from "react/jsx-runtime";
export const expandIcon = (expandAllControl, rowExpandable) =>
// eslint-disable-next-line react/display-name
_ref => {
  let {
    expanded,
    onExpand,
    record
  } = _ref;
  if (expandAllControl !== 'uncontrolled') return null;
  if (rowExpandable(record) !== true) return null;
  if (expanded) {
    return /*#__PURE__*/_jsx(ChevronDownIcon, {
      onClick: e => onExpand(record, e, expanded)
    });
  }
  return /*#__PURE__*/_jsx(ChevronRightIcon, {
    onClick: e => onExpand(record, e, expanded)
  });
};